export const orderAppealMixin = {
  data () {
    return {
      appealStatusOptions: [
        {label: '申诉中', value: 1},
        {label: '申诉成功', value: 2},
        {label: '申诉失败', value: 3},
        {label: '已撤回', value: 4},
        {label: '超时关闭', value: 5},
      ],
    }
  },
  computed: {
    ...Vuex.mapState({}),
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/views/order/mixins/order-appeal.mixins.js